module.exports = __webpack_public_path__ + "390b27195819d573766ae0797dfd11cd.png";